import styled from '@emotion/styled';
import React from 'react';
import { Header as SemanticHeader, Icon } from 'semantic-ui-react';

interface MdnLinkProps {
	link: string;
}

const Header = styled(SemanticHeader)`
	margin: 10px !important;
	margin-left: 48px !important;
`;

const ExternalIcon = styled(Icon)`
	font-size: 80% !important;
	padding-left: 8px !important;
`;

export const MdnLink: React.FC<MdnLinkProps> = ({ link, children }) => {
	return (
		<Header as={'h1' as const}>
			<a href={link} target="_blank" rel="noopener noreferrer">
				{children}
				<sup>
					<ExternalIcon name="external" />
				</sup>
			</a>
		</Header>
	);
};
